import React, { Component } from 'react'
import './assessment-chart.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDoubleRight,
  faArrowDown,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons'
import SchoolUserApi from '../../../apis/student'
import Loading from '../../common/loading/loading'
import IMDStudentWinnersList from '../imd-student-winners/imd-student-winners-list'
import { ImageConstants, Constants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid
} from 'recharts'

class AssessmentChart extends Component {
  state = {
    imdReport: {},
    isLoading: false,
    nationalAverage: 0,
    performanceReport: {}
  }
  constructor (props) {
    super(props)
    this.gmcAllowed = this.props.gmcAllowed
  }

  componentDidMount () {
    const { selectedClass } = this.props
    const payload = {}
    if (selectedClass && selectedClass !== 'All') payload.class = selectedClass
    this.getIMDReport(payload)
    this.getIMDNationalAverage(payload)
    this.getIMDPerformaceReport(payload)
  }

  getIMDReport = (payload = {}) => {
    this.setState({
      isLoading: true
    })
    payload.eventId = this.gmcAllowed ? Constants.GMC_EVENT_ID: Constants.IMD_EVENT_ID
    SchoolUserApi.getIMDReport(payload)
      .then(response => {
        this.setState({
          imdReport: response,
          isLoading: false
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  getIMDNationalAverage = (payload = {}) => {
    payload.eventId = this.gmcAllowed ? Constants.GMC_EVENT_ID: Constants.IMD_EVENT_ID
    SchoolUserApi.getIMDNationalAverage(payload)
      .then(response => {
        this.setState({
          nationalAverage: response.nationalAverage || 0
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  getIMDPerformaceReport = (payload = {}) => {
    payload.eventId = this.gmcAllowed ? Constants.GMC_EVENT_ID: Constants.IMD_EVENT_ID
    SchoolUserApi.getIMDPerformaceReport(payload)
      .then(response => {
        this.setState({
          performanceReport: response
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  viewDetails = screen => {
    this.props.viewDetails(this.gmcAllowed ? 'students': screen)
  }

  getIMDWinnersList(payload) {
    this.studentWinners.getIMDWinnersList(payload);
  }

  renderSkillChart = (baselinePercentage, finishlinePercentage) => {
    return (
      <>
        <div className='skill-chart'>
          <div>
              <div
                className={`horizontal-bar-${Math.round(baselinePercentage) ||
                  1} mt-2 text-right`}
              ><span>{Math.round(baselinePercentage) || 0}%</span></div>
            
          </div>
          <div>
              <div
                className={`final-assessment horizontal-bar-${Math.round(
                  finishlinePercentage
                ) || 1} mt-2 text-right`}
              ><span>{Math.round(finishlinePercentage) || 0}%</span></div>
            
          </div>
        </div>
      </>

    )
  }


  render () {
    const { imdReport, nationalAverage, performanceReport } = this.state
    const { selectedClass, gmcAllowed } = this.props
    return (
      <div className='assesment-chart'>
        {this.state.isLoading && <Loading style={{ top: '100px' }}></Loading>}
        {!gmcAllowed &&
        <div className='row'>
          <div className='col'>
            <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 mb-3'>
              <div className='cw-plain-card-wrapper-winners'>
                <div className='header-text'>STUDENTS WINNERS</div>
                <div className='mt-5'>
                  <IMDStudentWinnersList
                    selectedClass={selectedClass}
                    ref={instance => {
                      this.studentWinners = instance
                    }}
                    fromScreen='assessment-chart'
                    gmcAllowed={gmcAllowed}
                  />

                  <div
                    className='view-details cursor-pointer'
                    onClick={_ => this.viewDetails('winners')}
                  >
                    View Details{' '}
                    <FontAwesomeIcon
                      icon={faAngleDoubleRight}
                      color='#008FFF'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        }
        <div className='row'>
          <div className='col-6'>
            <div className='cw-plain-card cw-plain-card-wrapper-top mr-2'>
              <div className='row'>
                <div className='col-6'>
                  <div className='header-text'>STUDENTS</div>
                  <div className='student-chart mt-5'>
                    <div
                      className={`vertical-bar-${Math.round(
                        (imdReport.studentCount / imdReport.studentCount) * 100
                      ) || 1}`}
                    ></div>
                    <div
                      className={`vertical-bar-${Math.round(
                        (imdReport.baselineCompletedCount /
                          imdReport.studentCount) *
                          100
                      ) || 1}`}
                    ></div>
                    <div
                      className={`vertical-bar-${Math.round(
                        (imdReport.eventWorkflowTaken /
                          imdReport.studentCount) *
                          100
                      ) || 1}`}
                    ></div>
                    {!gmcAllowed &&
                      <div
                        className={`vertical-bar-${Math.round(
                          (imdReport.finalAssessmentCompletedCount /
                            imdReport.studentCount) *
                            100
                        ) || 1}`}
                      ></div>
                    }
                  </div>
                </div>
                <div className='col-6 text-right'>
                  <div className='count-details pb-2'>
                    <div className='count-number'>{imdReport.studentCount}</div>
                    <div className='count-title'>Students signed up</div>
                  </div>
                  <div className='count-details pb-2'>
                    <div className='count-number'>
                      {imdReport.baselineCompletedCount}
                    </div>
                    <div className='count-title'>Taken Baseline Assessment</div>
                  </div>
                  <div className='count-details pb-2'>
                    <div className='count-number'>
                      {imdReport.eventWorkflowTaken}
                    </div>
                    <div className='count-title'>
                      Completed Qualifying Course
                    </div>
                  </div>
                  {!gmcAllowed &&
                    <div className='count-details pb-2'>
                      <div className='count-number'>
                        {imdReport.finalAssessmentCompletedCount}
                      </div>
                      <div className='count-title'>
                        Taken Finshline Assessment
                      </div>
                    </div>
                  }
                  <div
                    className='view-details cursor-pointer'
                    onClick={_ => this.viewDetails('students')}
                  >
                    View Details{' '}
                    <FontAwesomeIcon
                      icon={faAngleDoubleRight}
                      color='#008FFF'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-6'>
            <div className='cw-plain-card cw-plain-card-wrapper-top ml-2'>
              <div className='header-text'>IMPROVEMENT</div>
              <div className='pt-4'>
                <div className='count-title'>
                  Average Baseline assessment Score
                </div>
                <div className='mt-2'>
                  <div
                    className={`horizontal-bar-${Math.round(
                      imdReport.baselineAvgScore
                    ) || 1}`}
                  ></div>
                  {Math.round(imdReport.baselineAvgScore) < 100 && (
                    <div
                      className={`horizontal-bar-${100 -
                        (Math.round(imdReport.baselineAvgScore) || 1)}`}
                    ></div>
                  )}
                </div>
                <div className='count-number text-center'>
                  {Math.round(imdReport.baselineAvgScore) || 0}%
                </div>
              </div>
              {!gmcAllowed &&
               <div>
                <div className='count-title'>
                  Average Finishline assessment Score
                </div>
                <div className='mt-4 final-assessment-bar-container'>
                  <div
                    className={`final-assessment horizontal-bar-${Math.round(
                      imdReport.finalAssessmentAvgScore
                    ) || 1}`}
                  ></div>
                  {Math.round(imdReport.finalAssessmentAvgScore) < 100 && (
                    <div
                      className={`final-assessment horizontal-bar-${100 -
                        (Math.round(imdReport.finalAssessmentAvgScore) || 1)}`}
                    ></div>
                  )}
                  <div
                    className={`map-pin-${Math.round(nationalAverage) || 0}`}
                  >
                    <img
                      className='cursor-pointer'
                      src={getImageSource(ImageConstants.INDIA_MAP_PIN)}
                    />
                  </div>
                </div>
                <div className='count-number text-center'>
                  {Math.round(imdReport.finalAssessmentAvgScore) || 0}%
                </div>
                <div className='mb-3 nation-average-container'>
                  <img
                    className='cursor-pointer'
                    src={getImageSource(ImageConstants.INDIA_MAP_ICON)}
                  />{' '}
                  <span className='nation-average-text'>National Average </span>
                  <span className='nation-average'>
                    {Math.round(nationalAverage)}%
                  </span>
                </div>
              </div> 
              }
              <div
                className='view-details text-right mt-4 cursor-pointer pb-4'
                onClick={_ => this.viewDetails('improvement')}
              >
                View Details{' '}
                <FontAwesomeIcon icon={faAngleDoubleRight} color='#008FFF' />
              </div>
            </div>
          </div>
        </div>
        {!gmcAllowed &&
        <>
          <div className='row mt-5'>
            <div className='col'>
              <div className='chart-title-text ml-4 mb-1'>Evaluation Bucket</div>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                <div className='row'>
                  <div className='col-4 text-center evaluation-bucket'>
                    <div className='evaluation-chart'>
                      <div className='evaluation-chart-text'>
                        {imdReport.noviceStudents}
                      </div>
                      <div className='evaluation-chart-sub-text'>Student(s)</div>
                    </div>
                    <div className='chart-title-text pt-4'>{`Novice`}</div>
                    <div className='chart-title-text'>{`(<50% score)`}</div>
                  </div>
                  <div className='col-4 text-center evaluation-bucket'>
                    <div className='evaluation-chart'>
                      <div className='evaluation-chart-text'>
                        {imdReport.proficientStudents}
                      </div>
                      <div className='evaluation-chart-sub-text'>Student(s)</div>
                    </div>
                    <div className='chart-title-text pt-4'>{'Proficient'}</div>
                    <div className='chart-title-text'>{'(50-80% score)'}</div>
                  </div>
                  <div className='col-4 text-center evaluation-bucket'>
                    <div className='evaluation-chart'>
                      <div className='evaluation-chart-text'>
                        {imdReport.advancedStudents}
                      </div>
                      <div className='evaluation-chart-sub-text'>Student(s)</div>
                    </div>
                    <div className='chart-title-text pt-4'>{'Advance'}</div>
                    <div className='chart-title-text'>{'(>80%)'}</div>
                  </div>
                </div>
                <div
                  className='view-details text-right mt-4 cursor-pointer pb-4'
                  onClick={_ => this.viewDetails('evaluation')}
                >
                  View Details{' '}
                  <FontAwesomeIcon icon={faAngleDoubleRight} color='#008FFF' />
                </div>
              </div>
            </div>
          </div>
          <div className='row mt-5'>
            <div className='col'>
              <div className='chart-title-container'>
                <div className='chart-title-text ml-4 mb-1'>
                  Skill Comparision{' '}
                </div>
                <div className='chart-title-legend text-right'>
                  <span className='skill-list'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.KNOWLEDGE)}
                    />
                    <span className='skill-title'>Knowledge</span>
                  </span>
                  <span className='skill-list'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.CALCULATION)}
                    />
                    <span className='skill-title'>Calculation</span>
                  </span>
                  <span className='skill-list'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.MODELING)}
                    />
                    <span className='skill-title'>Modeling</span>
                  </span>
                  <span className='skill-list'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.COMPREHENSION)}
                    />
                    <span className='skill-title'>Comprehension</span>
                  </span>
                </div>
              </div>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                <div className='skill-legends'>
                  <div className='skill-list'>Baseline assessment</div>
                  <div className='skill-list'>Finishline assessment</div>
                </div>
                <div className='skill-container pt-5'>
                  <div className='skill-img-container'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.KNOWLEDGE)}
                    />
                  </div>
                  {
                    this.renderSkillChart(
                      performanceReport?.baselinePercentage?.knowledge,
                      performanceReport?.finishlinePercentage?.knowledge
                    )
                  }
                </div>
                <div className='skill-container pt-5'>
                  <div className='skill-img-container'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.CALCULATION)}
                    />
                  </div>
                  {
                    this.renderSkillChart(
                      performanceReport?.baselinePercentage?.calculation,
                      performanceReport?.finishlinePercentage?.calculation
                    )
                  }
                </div>
                <div className='skill-container pt-5'>
                  <div className='skill-img-container'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.MODELING)}
                    />
                  </div>
                  {
                    this.renderSkillChart(
                      performanceReport?.baselinePercentage?.modeling,
                      performanceReport?.finishlinePercentage?.modeling
                    )
                  }
                </div>
                <div className='skill-container pt-5'>
                  <div className='skill-img-container'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.COMPREHENSION)}
                    />
                  </div>
                  {
                    this.renderSkillChart(
                      performanceReport?.baselinePercentage?.comprehension,
                      performanceReport?.finishlinePercentage?.comprehension
                    )
                  }
                </div>
                <div
                  className='view-details text-right mt-4 cursor-pointer pb-4'
                  onClick={_ => this.viewDetails('performance')}
                >
                  View Details{' '}
                  <FontAwesomeIcon icon={faAngleDoubleRight} color='#008FFF' />
                </div>
              </div>
            </div>
          </div>
        </>
        }
        {gmcAllowed &&
         <div className='row mt-5'>
            <div className='col'>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                <div className='header-text mb-5'>COURSE COMPLETION</div>
                {imdReport.chartData && (
                  <ResponsiveContainer width={'100%'} height={400}>
                    <LineChart
                      data={imdReport.chartData}
                      margin={{
                        top: 5,
                        right: 30
                      }}
                    >
                      <CartesianGrid vertical={false} />
                      <XAxis dataKey='name' />
                      <YAxis
                        padding={{ right: 20 }}
                        axisLine={false}
                        dataKey='pv'
                      />
                      <Line
                        type='monotone'
                        dataKey='pv'
                        stroke='#19da4d'
                        strokeWidth={5}
                        activeDot={false}
                        dot={false}
                        legendType={'none'}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                )}
                <div
                  className='view-details text-right mt-4 cursor-pointer pb-4'
                  onClick={this.viewDetails}
                >
                  View Details{' '}
                  <FontAwesomeIcon icon={faAngleDoubleRight} color='#008FFF' />
                </div>
                <div className='chart-legends'>
                  <div className='legent-title vertical-text pt-2'>
                    Students{' '}
                    <FontAwesomeIcon icon={faArrowDown} color='#535353' />
                  </div>
                  <div className='legent-title pl-3'>
                    Qualifying course completion %{' '}
                    <FontAwesomeIcon icon={faArrowRight} color='#535353' />
                  </div>
                </div>
              </div>
            </div>
         </div>
        }
      </div>
    )
  }
}

export default AssessmentChart
